import React from 'react';

import useUserFirstName from '@hooks/useUserFirstName';

const MyTIHeader = ({ initialCurrentUser }) => {
  const firstName = useUserFirstName({ userName: initialCurrentUser?.name });
  const tempModifier = Math.random() > 0.5 ? 'Home' : 'Hub';

  const nounToUse = firstName ? `${firstName}’s` : 'My';

  return (
    <header className="w-full">
      <h1 className="m-0 break-words text-center font-suisse-screen text-headline-alt-md md:text-left md:text-headline-alt-lg">
        {nounToUse} {tempModifier}
      </h1>
    </header>
  );
};

export default MyTIHeader;
